import type { ColorModeTokens, ThemePreset } from "../tokens"

/**
 * FL-Theme, imported from tweakcn
 * (https://tweakcn.com/r/themes/cmq57ht7w000204l2axo6ho9v). Values kept in
 * oklch as the source provides them. Sky blue primary on a cool grey paper
 * background, deep navy secondary/contrast bands, Inter font. The source
 * defines identical light and dark palettes, so dark mirrors light.
 */
const light: ColorModeTokens = {
  background: "oklch(0.968 0.0059 239.8195)",
  foreground: "oklch(0.3098 0.0748 248.9089)",
  card: "oklch(1 0 0)",
  cardForeground: "oklch(0.3098 0.0748 248.9089)",
  popover: "oklch(1 0 0)",
  popoverForeground: "oklch(0.3098 0.0748 248.9089)",
  primary: "oklch(0.7347 0.1447 228.9136)",
  primaryForeground: "oklch(1 0 0)",
  primaryHover: "oklch(0.6897 0.1365 228.9136)",
  secondary: "oklch(0.3098 0.0748 248.9089)",
  secondaryForeground: "oklch(1 0 0)",
  muted: "oklch(0.9352 0.0412 217.6616)",
  mutedForeground: "oklch(0.4186 0.0765 246.7831)",
  accent: "oklch(0.9352 0.0412 217.6616)",
  accentForeground: "oklch(0.3098 0.0748 248.9089)",
  destructive: "oklch(0.5014 0.2027 23.8197)",
  destructiveForeground: "oklch(0.934 0.0315 5.5116)",
  border: "oklch(0.8761 0 0)",
  input: "oklch(1 0 0)",
  ring: "oklch(0.3098 0.0748 248.9089)",
  contrast: "oklch(0.3098 0.0748 248.9089)",
  contrastForeground: "oklch(1 0 0)",
}

export const flThemePreset: ThemePreset = {
  name: "fl-theme",
  label: "FL-Theme",
  light,
  dark: light,
  radius: 0.75,
  font: "inter",
}
